import "./App.css";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Common/Header/Header";
import Footer from "./components/Common/Footer/Footer";
import Home from "./components/Pages/Home/Home";
import Courses from "./components/Pages/Courses/Courses";
import Login from "./components/Pages/Forms/Login/Login";
import SingUp from "./components/Pages/Forms/SignUp/SingUp";
import SingleCourseDetails from "./components/Pages/Courses/SingleCourseDetails/SingleCourseDetails";
import NotFoundPage from "./components/Pages/NotFoundPage/NotFoundPage";
import RequireAuth from "./components/Common/RequireAuth/RequireAuth";
import Blog from "./components/Pages/Blog/Blog";
import About from "./components/Pages/About/About";

function App() {
  return (
    <>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/courses" element={<Courses></Courses>}></Route>
        <Route
          path="/courses/:courseID"
          element={
            <RequireAuth>
              <SingleCourseDetails></SingleCourseDetails>
            </RequireAuth>
          }
        ></Route>
        <Route path="/blog" element={<Blog></Blog>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="/login" element={<Login></Login>}></Route>
        <Route path="/signup" element={<SingUp></SingUp>}>
          {" "}
        </Route>

        <Route path="*" element={<NotFoundPage></NotFoundPage>}></Route>
      </Routes>
      <Footer></Footer>
    </>
  );
}

export default App;
